export default __webpack_public_path__ + "static/media/rain-sun-cloud.b87a32ec.png";